module.exports = __webpack_public_path__ + "static/media/jasper-30.64cdaa5b.jpg";